export default {
  index: {
    tsevents:"最新活动",
    education:"教育",
    charity:"公益慈善",
    viewdetails:"查看详情",
    homepage:"主页",
    breadcrumbtitle:'音乐总监',
    aboutus:"关于我们",
    contactus:'联络我们',
    copyright:'大湾区管弦乐团 版权所有',
    back:'返回',
    adminlogin:'管理登录',
    title:'大湾区管弦乐团',
    privacypolicy:'免责条款',
    disclaimerclause:'私隐政策',
    termsconditionsuse:'使用条款细则',
  },
}

